<template>
    <b-col cols=12>
        <b-list-group flush>
            <b-card v-if="getMovements().length === 0" no-body class='p-2'>
                <div style="height: 135px; display: flex; justify-content: center; align-items: center;">
                    <h6 class='mb-0 color-primary'>The list is empty</h6>
                </div>
            </b-card>
            <b-list-group-item
            button
            style='background: none;'
            class='p-0 mb-2'
            v-for="(item, index) in getMovements()" v-bind:key="index"
            >
            <b-card no-body class='p-2'>
                <b-container>
                    <b-row class='box'>
                        <b-col cols=2  class='p-0'>
                            <div class="wraper">
                                <div class='icon'>
                                    <div class="wraper">
                                        <SmartGlobalIcon
                                            v-bind="{width: 25,height: 25,fill: '#212529'}"
                                        />
                                    </div>
                                </div>
                            </div>
                        </b-col>
                        <b-col cols=10 class='pt-3'>
                            <b-row>
                                <b-col cols=12 sm=6 class='txt-color-secondary'>
                                    <h5 class=''>Locked for {{item.times}}</h5>
                                </b-col>
                                <b-col cols=12 sm=6 style='color: #A7A4A4' class='text-left text-sm-right'>
                                    <h6>Ends is {{item.contador}}</h6>
                                </b-col>
                                <b-col cols=12 sm=5 class='txt-color-secondary text-left'>
                                    <h6 style="width: 200px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">
                                            <a target="_blank" :href="'https://tronscan.io/#/address/' + item.address" style='color: #A7A4A4'>{{item.address}}</a></h6>
                                </b-col>
                                <b-col cols=12 sm=7 class='txt-color-primary color-primary text-left text-sm-right pl-sm-0'>
                                    <h6 class='mb-0' ><strong class="pl-1"> {{item.value}} SGBT</strong></h6>
                                    <h6 style="color: #A7A4A4; font-size: 0.8rem;"> -- USD</h6>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-container>
                <div class='txt-color-secondary text-center' style="padding-top: 7px; border-top: 0.25px solid #414042;">
                    <a target="_blank" :href="'https://tronscan.io/#/transaction/' + item.id" style='color: #A7A4A4'>Show Details</a>
                </div>
            </b-card>
            </b-list-group-item>
        </b-list-group>
    </b-col>
</template>
<script>
import SmartGlobalIcon from '@/components/icons/SmartGlobalIcon'
export default {
  props: [
    'list'
  ],
  components: {
    SmartGlobalIcon
  },
  data () {
    return {
    }
  },
  computed: {
    getMovements () {
      return this.list
    }
  }
}
</script>
<style>
</style>
